export interface INote {
  id: number;
  note: string;
  pictures: Array<{
    mimetype: string;
    virtualpath: string;
  }>;
  createdBy: string;
  createdOn: Date | string;
}
export enum NoteType {
  internalNote = 1,
  externalNote = 2,
}
